/**
 * Resolves a translation from an array by language code.
 * Falls back to the first element if no match is found.
 */
export function resolveTranslation<T extends { lang: string }>(translations: T[], lang: string): T | undefined {
  if (translations.length === 0) return undefined
  return translations.find((t) => t.lang === lang) ?? translations[0]
}
